export default __webpack_public_path__ + "static/media/close.282390ba.svg";